import * as React from 'react';
import * as _ from 'lodash'
import { useHistory } from 'react-router-dom'
import { Card, Image, Form, Col, Row, Button } from 'react-bootstrap';
import { callIncoming, dialerModalClose } from '../../redux/actions';
import config from '../../constants/config';
import CustomModal from '../../components/CustomModal';
import { connect, useSelector, useDispatch } from 'react-redux'
import { Device, Call } from '@twilio/voice-sdk';
import engineerImg from '../../assets/images/engineer.png';

import { ButtonLoadingOld } from '../../components/ButtonLoading/ButtonLoadingOld';

import telephonyService from '../../service/telephonyService';
import TimerView from '../../components/TimerView';

import './style.css';
import { copyObject } from '../../utils';
import { css } from 'glamor';
import { IAppState } from '../../redux/reducers';
import { TelephonyStateT } from '../../redux/reducers/twilioReducer';
import { currentUserIsAdmin, currentUserIsManager, currentUserIsWorker } from '../../utils/currentUser';
import { AxiosInstance } from '../../utils/RequestMethods'
const style = {
  bgRinging: css({ "background": 'linear-gradient(to top, #525F6C5E, 30%, #FAA9455E)' }),
  bgConnect: css({ "background": 'linear-gradient(to top, #525F6C5E, 30%, #4DAF7C)' }),
  bgEndCall: css({ "background": 'linear-gradient(to top, #525F6C5E, 30%, #F62459)' })
}
const useForceUpdate = () => {
  const [, setState] = React.useState();
  return () => setState(null);
}
interface TwilioDialerT {
  token?: string
}


enum CallDirectionT {
  Incoming = "INCOMING",
  Outgoing = "OUTGOING"
}
// enum CallDirectionT {
//     IN, OUTGOING
// }

type CallDirectionTStrings = keyof typeof CallDirectionT;


const TwilioDialer: React.FunctionComponent<TwilioDialerT> = ({ }): JSX.Element => {

  const history = useHistory()
  const auth = useSelector((state: IAppState) => state.auth)
  const telephonyState = useSelector((state: IAppState) => state.telephonyState)
  const dispatch = useDispatch()
  const [tokenTwilio, setTokenTwilio] = React.useState('')

  const [myNumber, setMyNumber] = React.useState('')
  const [statusDirection, setStatusDirection] = React.useState('')
  const [isMute, setIsMute] = React.useState(false)
  const [status, setStatus] = React.useState(null)
  const [callDirection, setCallDirection] = React.useState(null)
  const [clickDisconnect, setClickDisconnect] = React.useState(false)

  const [jobId, setJobId] = React.useState(null);
  const [callParams, setCallParams] = React.useState({
    To: "",
    From: "",
  })
  const [parameters, setParameters] = React.useState({
    From: "",
    To: ""
  })
  const [state, setState] = React.useState({});
  const [isOpen, setIsOpen] = React.useState(false)
  const [isStarted, setIsStarted] = React.useState(false);
  const connRef = React.useRef(null)
  const deviceRef = React.useRef(null)
  const timerRef = React.useRef(null)
  const callParamsRef = React.useRef({
    To: "",
    From: "",
  })

  // Device is created with token in initTelephonyStart — placeholder ref until then
  const device = deviceRef.current as InstanceType<typeof Device> | null

  const isAdmin = currentUserIsAdmin()
  const isManager = currentUserIsManager()
  const isWorker = currentUserIsWorker()
  const canUseTwilio = isAdmin || isManager || isWorker

  React.useEffect(() => {

    if (canUseTwilio) {
      getTokenTwilio().then(() => {

      })
      // console.log("start->Twilio")
    }

  }, [])


  React.useEffect(() => {
    setIsOpen(telephonyState.isOpen)
  }, [telephonyState.isOpen])

  React.useEffect(() => {


    if (telephonyState.params != null && !_.isEqual(telephonyState.params, callParams)) {

      makeCall(telephonyState.params)
    }
    setCallParams(telephonyState.params)
  }, [telephonyState.params])






  const isRefreshingRef = React.useRef(false)

  /**
   *
   */
  const refreshToken = async () => {
    return await AxiosInstance.post(`${config.url.twilio}/token`, { platform: "website" })
  }

  /**
   * setupTwilio
   * @param token
   */
  const setupTwilio = (token) => {
    setTokenTwilio(token)

    // initTelephonyStart(token, auth.userData.ID)
  }


  React.useEffect(() => {

    if (tokenTwilio != "") {

      initTelephonyStart(tokenTwilio)
    }

  }, [tokenTwilio])

  /**
    *
    * @param access_token
    */
  const initTelephonyStart = async (access_token) => {
    if (!access_token || typeof access_token !== 'string' || access_token.trim() === '') {
      console.error('TwilioDialer: invalid token received, aborting Device init', access_token)
      return
    }
    if (access_token.split('.').length !== 3) {
      console.error('TwilioDialer: token does not look like a valid JWT:', access_token)
      return
    }
    // Decode and log the token payload to diagnose WebSocket URL issues
    try {
      const payload = JSON.parse(atob(access_token.split('.')[1]))
      console.log('TwilioDialer: token payload:', payload)
    } catch (e) {
      console.error('TwilioDialer: failed to decode token payload', e)
    }
    try {
      if (deviceRef.current) {
        deviceRef.current.destroy()
        deviceRef.current = null
      }
      console.log('TwilioDialer: initializing Device, token length:', access_token.length)
      const newDevice = new Device(access_token, {
        logLevel: 1,
      })
      deviceRef.current = newDevice
      listening()
      await newDevice.register()
      setIsStarted(true)
      console.log('TwilioDialer: Device registered successfully')
    } catch (error: any) {
      console.error('TwilioDialer: Device init/register failed:', error?.message || error)
    }
  }


  /**
   * getTokenTwilio
   */
  const getTokenTwilio = async () => {
    AxiosInstance.post(`${config.url.twilio}/token`, { platform: "website" }).then((res) => {
      if (res && res.data) {
        // console.log("getTokenTwilio->res",res.data)
        setupTwilio(res.data.token)
      }
      return true;
    }).catch((error) => {
      console.log("error", error)
    })
  }




  /**
   *
   */
  const listening = () => {
    const dev = deviceRef.current
    if (!dev) return

    dev.on('registered', () => {
      console.log("twilio Ready");
    });

    dev.on('connect', (conn: Call) => {
      const direction = conn.direction
      setStatus("connect")
      setParameters(conn.parameters as { From: string; To: string })
      const isOutgoing = direction === Call.CallDirection.Outgoing
      let statusText = `is Connected ${isOutgoing ? conn.customParameters?.get("To") ?? "" : conn.parameters.From}`
      setStatusDirection(statusText)
      if (!isOutgoing) {
        connRef.current = conn
      }
      startTimer()
    });

    dev.on('error', (error) => {
      console.log('Twilio.Device Error: ', error.message);
      // 31209 = version not supported, 31205 = token expired — don't loop
      if (error.code === 31209) {
        console.error('Twilio SDK version not supported by server. Please check your Twilio account settings.')
        return  // do NOT call lostConnect to avoid offline loop
      }
      lostConnect()
    });

    dev.on('cancel', (conn: Call) => {
      lostConnect("Call cancelled by caller.");
    })

    dev.on('disconnect', (conn: Call) => {
      lostConnect("Call ended.")
    });

    dev.on('incoming', (conn: Call) => {
      console.log("twilio incoming", conn)
      connRef.current = conn
      if (conn && conn.customParameters) {
        setJobId(conn.customParameters.get("jobId"))
      }
      setStatus("incoming")
      setCallDirection(CallDirectionT.Incoming)
      setStatusDirection(`Incoming call from ${conn.parameters.From} ...`)
      callIncomingAction()
      setParameters(conn.parameters as { From: string; To: string })
    });

    dev.on('tokenWillExpire', () => {
      refreshToken().then((res) => {
        if (res && res.data && deviceRef.current) {
          deviceRef.current.updateToken(res.data.token)
        }
      })
    })

    dev.on("unregistered", offline);
  }


  /**
   * Called when device goes offline — refresh token once, prevent loop with flag
   */
  const offline = () => {
    console.log("twilio->offline")

    if (isRefreshingRef.current) return   // already refreshing, skip
    isRefreshingRef.current = true

    refreshToken().then((res) => {
      console.log("offline->refreshToken", res)
      if (res && res.data && deviceRef.current) {
        // @twilio/voice-sdk: use updateToken instead of setup
        deviceRef.current.updateToken(res.data.token)
      }
    }).catch((err) => {
      console.log("offline->refreshToken error", err)
    }).finally(() => {
      // allow next refresh after 10 seconds minimum
      setTimeout(() => {
        isRefreshingRef.current = false
      }, 10000)
    })
  }

  const destroy = () => {
    if (deviceRef.current) {
      deviceRef.current.destroy()
      deviceRef.current = null
    }
  }

  const readState = () => {
    console.log("readState", callDirection)
  }
  /**
   *
   */
  const startTimer = () => {
    if (timerRef.current) {
      timerRef.current.start()
    }
  }

  /**
   *
   */
  const stopTimer = () => {
    if (timerRef.current) {
      timerRef.current.stop()
    }
  }

  const makeCall = (params) => {
    console.log("makeCall", params)
    callParamsRef.current = params

    setIsMute(false)
    if (params && deviceRef.current) {
      setCallDirection(CallDirectionT.Outgoing)
      setStatusDirection(`Calling ${params.To} ...`)
      params = {
        ...params, ...{
          // token: tokenIdentity
        }
      }

      connRef.current = deviceRef.current.connect(params);
      console.log("isMute", connRef.current)
      connRef.current.on('accept', (conn) => {
        // console.log("isMute", conn.isMute())
        console.log("accept", conn)
      })
      connRef.current.on('ringing', function (hasEarlyMedia) {
        console.log("ringing", hasEarlyMedia)
      });
      connRef.current.on('disconnect', function (conn) {
        console.log("the call has ended");
      });
      connRef.current.on('mute', (boolean, connection) => {
        console.log("mute", boolean);
        console.log("mute->connection", connection);
      })
    }
  }

  /**
   * accept
   */
  const accept = () => {
    setStatus("accept")

    if (connRef.current) {
      connRef.current.accept()
    }
  }

  /**
   *
   */
  const closeAutomatically = () => {
    setTimeout(() => {
      setStatus(null)
      setClickDisconnect(false)
      closeModal()
    }, 3000);
  }


  /**
   * closeModal
   */
  const closeModal = () => {
    ignore()
    if (deviceRef.current) {
      deviceRef.current.disconnectAll();
    }
    dispatchCloseModal()

  }


  // action redux
  const callIncomingAction = () => {
    dispatch(callIncoming())
  }
  /**
   *
   */
  const dispatchCloseModal = () => {
    setStatus(null)
    dispatch(dialerModalClose())
  }

  /**
   *
   * @param msg
   */
  const lostConnect = (msg = "Hanging up...") => {
    stopTimer()
    // rest values
    setJobId(null)


    setStatus("endCall")

    setCallDirection(null)
    setStatusDirection(msg)
    closeAutomatically()
    if (connRef.current) {
      connRef.current = null
    }
  }


  const ignore = () => {
    if (connRef.current) {
      connRef.current.ignore()
      lostConnect("Call ignored.")
    }
  }
  /**
   *
   */
  const rejectCall = (): void => {
    if (connRef.current) {
      console.log("reject", connRef.current);
      connRef.current.reject()
      lostConnect("Call ended.")
    }
  }



  /**
   *
   */
  const endCall = (): void => {
    console.log("clickDisconnect", clickDisconnect)
    console.log("callDirection", callDirection)
    if (clickDisconnect) {
      return close()
    }

    setClickDisconnect(true)

    if (callDirection == CallDirectionT.Incoming) {
      if (status == "connect") {
        return disconnectCall()
      } else {

        return ignore()
      }

    } else if (callDirection == CallDirectionT.Outgoing) {
      disconnectCall()
      lostConnect()
    }


  }

  /**
   *
   */
  const disconnectCall = () => {
    if (connRef.current) {
      connRef.current.disconnect()
    }
  }
  /**
   *
   */
  const close = () => {
    disconnectCall()
    if (deviceRef.current) {
      deviceRef.current.disconnectAll();
    }

    setClickDisconnect(false)
    dispatchCloseModal()
  }

  /**
   *
   */
  const onChangeMute = () => {
    setIsMute(!isMute)
    if (connRef.current) {
      connRef.current.mute(!isMute)

    }
  }


  const goJob = (id) => {

    history.push({
      pathname: `/job/${id}`
    })

  }

  const getClassBackground = (status) => {
    switch (status) {
      case "connect":
        return style.bgConnect
        break;
      case "endCall":
        return style.bgEndCall
        break;
      default:
        return style.bgRinging;
        break;
    }
  }

  const renderContainerDialer = () => {
    return (

      <div className={`d-flex flex-row justify-content-center align-items-center p-2  ${getClassBackground(status)}`}>


        <div className={"d-flex p-2"} >
          <Image style={{ width: 60, height: 60 }}
            src={engineerImg}></Image>
          <div className="d-flex  p-4" >
            <span style={{ fontWeight: 'bold' }}>{statusDirection}</span>
          </div>
        </div>
        {/* <div className={"d-flex p-2"} >

                </div> */}
        <div className={"d-flex p-2 flex-column"} >
          <div className={"d-flex p-2"} >
            <TimerView ref={timerRef} />
          </div>

          {/* <span>{status}</span> callDirection <span>{callDirection}</span> */}


          <div className={"d-flex flex-row"} >
            {status == "incoming" && <>
              {/* <ButtonLoading className="btn-success  dialer-button accept-button" onPress={() => accept()}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" className="svg">
                            <path d="M13.25 21.59c2.88 5.66 7.51 10.29 13.18 13.17l4.4-4.41c.55-.55 1.34-.71 2.03-.49C35.1 30.6 37.51 31 40 31c1.11 0 2 .89 2 2v7c0 1.11-.89 2-2 2C21.22 42 6 26.78 6 8c0-1.11.9-2 2-2h7c1.11 0 2 .89 2 2 0 2.49.4 4.9 1.14 7.14.22.69.06 1.48-.49 2.03l-4.4 4.42z" fill="white" />
                        </svg>
                    </ButtonLoading> */}
              {jobId && <Button className="btn-success  accept-button" onClick={() => {
                accept()

              }}>
                Accept
              </Button>}
              {jobId && <Button className="btn-success  accept-button" onClick={() => {
                accept()
                goJob(jobId)
              }}>
                Accept and Open Job
              </Button>}
            </>}


            <ButtonLoadingOld className={`btn-info   dialer-button  ${isMute ? "on" : ""} audio-button-${isMute ? "true" : "false"}`}
              onPress={() => onChangeMute()}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" className="svg">
                {isMute &&
                  <path className="on" d="M38 22h-3.4c0 1.49-.31 2.87-.87 4.1l2.46 2.46C37.33 26.61 38 24.38 38 22zm-8.03.33c0-.11.03-.22.03-.33V10c0-3.32-2.69-6-6-6s-6 2.68-6 6v.37l11.97 11.96zM8.55 6L6 8.55l12.02 12.02v1.44c0 3.31 2.67 6 5.98 6 .45 0 .88-.06 1.3-.15l3.32 3.32c-1.43.66-3 1.03-4.62 1.03-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c1.81-.27 3.53-.9 5.08-1.81L39.45 42 42 39.46 8.55 6z" fill="white"></path>}

                <path className="off" d="M24 28c3.31 0 5.98-2.69 5.98-6L30 10c0-3.32-2.68-6-6-6-3.31 0-6 2.68-6 6v12c0 3.31 2.69 6 6 6zm10.6-6c0 6-5.07 10.2-10.6 10.2-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c6.56-.97 12-6.61 12-13.44h-3.4z" fill="white"></path>
              </svg>
            </ButtonLoadingOld>
            <ButtonLoadingOld className="btn-danger dialer-button hangup-button" onPress={() => endCall()}>
              {clickDisconnect ? <i className="fa fa-close" /> :
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" className="svg">
                  <path d="M24 18c-3.21 0-6.3.5-9.2 1.44v6.21c0 .79-.46 1.47-1.12 1.8-1.95.98-3.74 2.23-5.33 3.7-.36.35-.85.57-1.4.57-.55 0-1.05-.22-1.41-.59L.59 26.18c-.37-.37-.59-.87-.59-1.42 0-.55.22-1.05.59-1.42C6.68 17.55 14.93 14 24 14s17.32 3.55 23.41 9.34c.37.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-4.95 4.95c-.36.36-.86.59-1.41.59-.54 0-1.04-.22-1.4-.57-1.59-1.47-3.38-2.72-5.33-3.7-.66-.33-1.12-1.01-1.12-1.8v-6.21C30.3 18.5 27.21 18 24 18z" fill="white"></path>
                </svg>}
            </ButtonLoadingOld>
          </div>


        </div>
      </div>



    )


  }
  // console.log("callDirectioneee", callDirection)
  // let number = callDirection == "in" ? callParams.To : parameters.From
  return (
    <div>

      {isOpen && renderContainerDialer()}
    </div >
  );

}

export default TwilioDialer

